<template>
<div class="pop_table04 scroll">
    <table class="tb-list01" summary="여론동향 뉴스 리스트">
        <caption>여론동향 뉴스 리스트</caption>
        <colgroup>
            <col>
            <col style="width:120px">
        </colgroup>
        <tbody>
        <tr v-for="(news, index) in newsDataList" :key="news.amnDataSqno">
            <!-- <a href="#" @click.prevent="viewNewsPopup(news.val1)"> -->
                <td class="alignL" v-html="news.val2"></td>
                <td>{{ news.val3 ? news.val3 : '-' }}{{ news.val4 }}</td>
            <!-- </a> -->
        </tr>
        <!-- <tr>
            <td class="alignL"><div class="text-ellipsis">사업 최대 5개 이상 출력</div></td>
            <td>2020-11-02 15:11</td>
        </tr> -->
        </tbody>
    </table>
</div>
</template>

<script>
export default {
    props: {
        paramObj: {
            type: Object,
            required: true
        }
    },
    created() {
        this.$store.dispatch('FETCH_NEWS_DATA_LIST', this.paramObj);
    },
	computed: {
		newsDataList() {
		    var data = this.$store.getters.getNewsDataList;
	        var reversedata = data.reverse();
	        return reversedata; 
		},
	},
    methods: {
        viewNewsPopup(url) {
            // 데이터의 특수문자 처리가 이상해서 임시로 아래와 같이 url 정보 처리함 (향후 정상 데이터 호출시 아래 줄 제거)
            var url = $("<textarea/>").html(url).text();

            $("#iPopupMobile2").attr("src", url);
            $("#newsPopup2").removeClass("hidden");
        }
    }
}
</script>

<style>

</style>